import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch } from "../../../app/hooks";
import ControlReturnsPage from "../../controlReturns/components/ControlReturnsPage";
import { fetchIncidentDetectionLapseReview } from "../../incidentDetectionLapseReview/logic/thunk";
import OtherAuditsPage from "../../otherAudits/components/OtherAuditsPage";
import WorkbenchTabs, { WorkbenchTab } from "./WorkbenchTabs";

const InspectionsAuditsPage: React.FC = () => {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (caseId) {
      dispatch(fetchIncidentDetectionLapseReview(caseId));
    }
  }, [caseId, dispatch]);

  const tabs: WorkbenchTab[] = [
    {
      key: "control-returns",
      label: "Control Returns",
      content: <ControlReturnsPage />,
    },
    {
      key: "other-audits",
      label: "Other Audits",
      content: <OtherAuditsPage />,
    },
  ];

  return (
    <div>
      <WorkbenchTabs
        tabs={tabs}
        contentCardClassName="border border-gray-100 shadow-overviewCard rounded-b-xl bg-white overflow-hidden"
        contentWrapperClassName="p-4 min-w-0"
      />
    </div>
  );
};

export default InspectionsAuditsPage;
